"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeFormControlStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeFormControlStyles = function makeFormControlStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiFormControl: {
      styleOverrides: {
        root: {
          '& label + [class*="MuiInput-formControl"]': {
            marginTop: 0
          },
          "& legend": {
            marginBottom: primitives.spacings[3]
          },
          "& .DhigTextInput--count": {
            color: tokens.colors["ink-on-background-60"].rgb,
            fontSize: primitives.fontSizes["1"],
            textAlign: "right",
            margin: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["0"])
          },
          "&.DhigDatepicker-FormControl": {
            '& [class*="MuiInput-root"]': {
              borderRadius: "".concat(primitives.borderRadii["medium"], " ").concat(primitives.borderRadii["medium"], " ").concat(primitives.borderRadii["none"], " ").concat(primitives.borderRadii["none"]),
              paddingRight: "".concat(primitives.spacings[4])
            }
          },
          '&.DhigDatepicker-FormControl [class*="MuiInput-root"].Mui-focused:not(.Mui-disabled):before': {
            boxShadow: "none"
          },
          '&.DhigDatepicker-FormControl [class*="MuiInput-root"]:hover': _objectSpread({
            boxShadow: "0px -2px 0px 0px ".concat(primitives.colors.accent.iris, " inset, 0px 0px 0px 1px rgba(0, 0, 0, 0.3) inset")
          }, tokens.transitions["state-blur"]),
          '&.DhigDatepicker-FormControl [class*="MuiInput-root"]:focus, &.DhigDatepicker-FormControl [class*="MuiInput-root"].Mui-focused': _objectSpread({}, tokens.effects["focus-ring"]),
          '&.DhigDatepicker-FormControl [class*="MuiInput-root"]:before, &.DhigDatepicker-FormControl [class*="MuiInput-root"]:after': {
            borderBottom: "".concat(primitives.borderWidths["large"], " solid transparent")
          },
          "&.DhigDatepicker-FormControl--active": {
            boxShadow: "none",
            '& [class*="MuiInput-root"]': {
              paddingRight: "".concat(primitives.spacings[4]),
              fontWeight: primitives.fontWeights.stout,
              boxShadow: "0px -2px 0px 0px ".concat(primitives.colors.accent.iris, " inset, 0px 0px 0px 1px rgba(0, 0, 0, 0.3) inset")
            }
          },
          "& .DhigDatepicker-TextInput--error": _objectSpread(_objectSpread({}, tokens.effects["field-error"]), {}, {
            fontWeight: primitives.fontWeights.stout,
            paddingRight: "14px",
            borderRadius: "".concat(primitives.borderRadii["medium"], " ").concat(primitives.borderRadii["medium"], " ").concat(primitives.borderRadii["none"], " ").concat(primitives.borderRadii["none"]),
            "&:before, &:after": {
              borderBottom: "".concat(primitives.borderWidths["medium"], " solid transparent")
            },
            "&:focus, &.Mui-focused": _objectSpread({}, tokens.effects["focus-ring"]),
            "&.Mui-focused:not(.Mui-disabled):before": {
              boxShadow: "none"
            }
          }),
          '&.DhigDatepicker-FormControl [class*="MuiInput-root"], &.DhigDatepicker-FormControl [class*="MuiInput-root"] .Mui-disabled': {
            fontWeight: primitives.fontWeights.stout
          }
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          "&.Mui-disabled": {
            opacity: tokens.opacities.disabled.opacity
          }
        },
        label: {
          "&.Mui-disabled": {
            color: tokens.colors["ink-on-background"].rgb
          }
        }
      }
    }
  };
};

exports.makeFormControlStyles = makeFormControlStyles;